import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Vaga } from './vaga.model';
import { Observable } from 'rxjs';
import { AppFilter } from "app/models/app-filter.model";
import { AbTipoVaga } from 'app/abstract/full-pages/vaga/tipo-vaga.abstract';


@Injectable({ providedIn: 'root' })
export class TipoVagaService extends AbTipoVaga {

  constructor(http: HttpClient) {
    super(http);
  }

  public getVagas() {
    return this.get("tipoVagas/all/");
  }

  public getAllTipoDeVagas(filter: AppFilter): Observable<any> {
    return this.get(`tipovagas/filter/${filter.encode()}`);
  }

  public saveTipoVaga(vaga: Vaga): Observable<any> {
    return this.save("tipoVagas/", vaga);
  }

  desativar(id: number) {
    return this.delete("tipoVagas/desativar/", id);
  }


}